import useTranslations from "@/shared/lang/useTranslations";
import { cn } from "@/shared/lib/utils";

import type { CardCopTopUpRates } from "../../types/cardCopTopUp.types";
import { formatCopRate } from "../../utils/cardCopTopUp";

export interface CopTopUpRateRowProps {
  rates: CardCopTopUpRates;
  locale: string;
  className?: string;
}

/**
 * What one dollar on the card cost in pesos, everything included — the answer to "what rate did I get". An
 * estimate until the card credits, and said so. Renders nothing without a rate.
 */
export function CopTopUpRateRow({ rates, locale, className }: CopTopUpRateRowProps) {
  const { t } = useTranslations("cards");
  const estimated = rates.cop_per_usd_estimated === true;
  const rate = formatCopRate(rates.cop_per_usd, "USD", locale, estimated);
  if (!rate) return null;

  return (
    <div className={cn("flex items-start justify-between gap-3 bg-muted/40 p-3.5", className)}>
      <span className="flex min-w-0 flex-col gap-0.5">
        <span className="text-[13px] font-semibold text-foreground">
          {t("txn_detail_field_exchange_rate")}
        </span>
        <span className="text-[11.5px] text-muted-foreground">
          {t(estimated ? "cop_top_up_rate_estimated_hint" : "cop_top_up_rate_hint")}
        </span>
      </span>
      <span className="shrink-0 text-right font-mono text-[15px] font-semibold tabular-nums text-foreground">
        {rate}
      </span>
    </div>
  );
}
